var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendarIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93784 5.65843H10.9916M3.93784 8.34089H7.46473M3.93784 0.964111V2.30534M10.9916 0.964111V2.30534M3.37354 13.0352H11.5559C12.346 13.0352 12.7411 13.0352 13.0429 12.889C13.3083 12.7605 13.5241 12.5553 13.6593 12.3029C13.8131 12.016 13.8131 11.6404 13.8131 10.8892V4.45132C13.8131 3.70015 13.8131 3.32457 13.6593 3.03767C13.5241 2.7853 13.3083 2.58012 13.0429 2.45153C12.7411 2.30534 12.346 2.30534 11.5559 2.30534H3.37354C2.58345 2.30534 2.18839 2.30534 1.88662 2.45153C1.62116 2.58012 1.40535 2.7853 1.2701 3.03767C1.11633 3.32457 1.11633 3.70015 1.11633 4.45132V10.8892C1.11633 11.6404 1.11633 12.016 1.2701 12.3029C1.40535 12.5553 1.62116 12.7605 1.88662 12.889C2.18839 13.0352 2.58344 13.0352 3.37354 13.0352Z",
    stroke: "#2E2BEB",
    strokeWidth: 1.00592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarIcon.299d345c.svg";
export { ForwardRef as ReactComponent };